import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import axios from 'axios';
import 'swiper/css';
import 'swiper/css/pagination';
import '../styles/testimonial.css';

const Testimonial = ({ language }) => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.get('http://localhost:5000/api/testimonials/approved');
        setTestimonials(res.data);
      } catch (error) {
        console.error('Failed to fetch testimonials', error);
      }
    };

    fetchTestimonials();
  }, []);

  return (
    <section className="testimonial-section py-5 bg-white">
      <div className="container">
   <h2 className="text-center fw-bold mb-5">
          {language === 'am' ? 'የአባላቶቻችን አስተያየቶች' : 'What Our Members Say'}
        </h2>        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={30}
          slidesPerView={1}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          loop={true}
          breakpoints={{
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="card shadow-sm h-100 p-4 testimonial-card">
                <p className="testimonial-text">“{item.message}”</p>
                <hr />
                <h6 className="fw-bold mb-0">{item.name}</h6>
                <small className="text-muted">Guest</small>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonial;
